import { call, select } from 'redux-saga/effects';

import * as $auth from 'modules/auth';
import * as api from '../api';

export const fetchSingleArtset = function* () {
  const token = yield select($auth.getToken);
  const publisherId = yield select($auth.getSelectedPublisherId);
  const artsets = yield call(api.fetchArtsets, { token, publisherId });
  return artsets.Records[0];
};
